import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  ReviewAbilityMutation as ReviewAbilityMutationType,
  ReviewAbilityMutationVariables,
} from "./__generated__/ReviewAbilityMutation";

const ReviewAbilityMutation = loader("./ReviewAbilityMutation.gql");

type ReviewAbilityMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: ReviewAbilityMutationType) => void;
}) => ReactElement;

export const ReviewAbilityMutationProvider: ReviewAbilityMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<ReviewAbilityMutationType, ReviewAbilityMutationVariables>(
    ReviewAbilityMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
      refetchQueries: ["AbilitiesQuery"],
      awaitRefetchQueries: true,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
